// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.

import Vue from 'vue'
import { IP_ADRESS } from './../deploy_conf.js'
import Vuetify from 'vuetify'
import './stylus/main.styl'

import App from './App'
import router from './router'

import { store } from './store'
import DateFilter from './Filters/date'
// import VueAudio from 'vue-audio'
import vueSmoothScroll from 'vue-smooth-scroll'
import VueAxios from 'vue-axios'
import VueAuthenticate from 'vue-authenticate'
import axios from 'axios'
import * as VueGoogleMaps from 'vue2-google-maps'
import PickLocation from './components/Partials/PickLocation.vue'
import PickLocationSingle from './components/Partials/PresentLocation.vue'
import PickLocationMultiple from './components/Partials/PresentMultipleLocations.vue'
import PickLocationMultipleGroups from './components/Partials/PresentMultipleLocationsGroups.vue'
import GroupCard from './components/Partials/GroupCard.vue'
import CollectionCard from './components/Partials/CollectionCard.vue'
import ArtefactCard from './components/Partials/ArtefactCard.vue'
import ArtefactCardMini from './components/Partials/ArtefactCardMini.vue'
import Slider1 from './components/Partials/Slider1.vue'
import Slider2 from './components/Partials/Slider2.vue'
import Slider3 from './components/Partials/Slider3.vue'
import LocationTab from './components/Partials/ArtefactSingleTab.vue'
import BottomRedAddButton from './components/Partials/BottomRedAddButton.vue'
import ArtefactPreview from './components/Partials/ArtefactPreview.vue'
import ChangePersonalInfo from './components/Partials/ChangePersonalInfo.vue'
import SearchGlobal from './components/Partials/SearchGlobal.vue'
import ListSwiper from './components/Partials/ListSwiper.vue'
import ThreeArtefactsCard from './components/Partials/ThreeArtefactsCard.vue'
import SimpleDescriptionSwiper from './components/Partials/SimpleDescriptionSwiper.vue'
import AddArtPartial from './components/Partials/AddArtefactPartial.vue'
import MultipleLocationsExplore from './components/Partials/MultipleLocationsExplore.vue'
import EditArtefactPartial from './components/Partials/EditArtefactPartial.vue'
import VueFuse from 'vue-fuse'
// var SocialSharing = require('vue-social-sharing');
 

import VueCookies from 'vue-cookies'
Vue.filter('date', DateFilter)
// Vue.use(SocialSharing);

Vue.use(VueFuse)
Vue.component('web-locations-explore', MultipleLocationsExplore)
Vue.component('web-edit-artefact', EditArtefactPartial)
Vue.component('web-add-artefact', AddArtPartial)
Vue.component('web-search-global', SearchGlobal)
Vue.component('web-location-picker', PickLocation)
Vue.component('web-location-present-single', PickLocationSingle)
Vue.component('web-location-present-multiple', PickLocationMultiple)
Vue.component('web-location-tab', LocationTab)
Vue.component('web-group-card', GroupCard)
Vue.component('web-collection-card', CollectionCard)
Vue.component('web-artefact-card', ArtefactCard)
Vue.component('web-artefact-card-mini', ArtefactCardMini)
Vue.component('web-slider1', Slider1)
Vue.component('web-slider2', Slider2)
Vue.component('web-slider3', Slider3)
Vue.component('web-location-present-multiple-groups', PickLocationMultipleGroups)
Vue.component('web-speed-dial-add', BottomRedAddButton)
Vue.component('web-artefact-preview', ArtefactPreview)
Vue.component('web-change-info', ChangePersonalInfo)
Vue.component('web-list-swiper', ListSwiper)
Vue.component('web-3-artefacts-card', ThreeArtefactsCard)
Vue.component('web-description-swiper', SimpleDescriptionSwiper)
Vue.use(VueCookies)

// Vue.component('vue-audio', VueAudio)

Vue.use(Vuetify)
Vue.use(vueSmoothScroll)
Vue.config.productionTip = false

Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDdBLpn48Wp6ivOI2CLEwfujRdmm72-rTk',
    libraries: 'places'
  }
})

Vue.mixin({
  computed: {
    gLang () {
      return this.$store.getters.loadGlobLang
    },
    lang () {
      return this.$store.getters.loadLang
    }
  }
})

Vue.use(VueAxios, axios)
Vue.use(VueAuthenticate, {
  baseUrl: IP_ADRESS + 'api/', // Your API domain

  providers: {
    facebook: {
      clientId: '202571340317455',
      redirectUri: IP_ADRESS + 'signin'
    },
    google: {
      clientId: '96967316383-joie7v1o18jqcrjqerbnimaad2lsgf4j.apps.googleusercontent.com',
      redirectUri: IP_ADRESS + 'signin'
    },
    live: {
      clientId: '2157aab6-1ebe-4ca3-ba18-5e8f8398f296',
      redirectUri: IP_ADRESS + 'signin'
    }
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js